export default function getHelloBraveCookiesReceiveUrl(mid: string, event?: string): string {
  if (event) return `devsisters-crpuz://invite?mid=${mid}&event=${event}`;
  return `devsisters-crpuz://invite?mid=${mid}`;
}
